// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-screens-wrapper[data-v-fae5bece] {\n  position: static;\n  height: 100%;\n}\n.loading-screen[data-v-fae5bece] {\n  position: absolute;\n  z-index: 9999;\n  height: 100%;\n  width: 100%;\n}\n.fade-enter-active[data-v-fae5bece] {\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.fade-enter[data-v-fae5bece] {\n  opacity: 0;\n}\n.flash-messages[data-v-fae5bece] .Vlt-flash {\n  left: 20px;\n  width: 380px;\n  margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
